import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "Play",
  "use": "Play-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Play\"><path fill-rule=\"evenodd\" d=\"M54 32L10 63V1z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol